import {verifiedFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'

export type UpdateIssueLabelsBulkRequest = {
  ids: string[]
  addedLabelIds: string[]
  removedLabelIds: string[]
}

type UpdateIssueLabelsBulkResponseData = {
  updateIssuesBulk: {
    jobId: string
  }
}

export type UpdateIssueLabelsBulkResponse = GraphQLResponse<UpdateIssueLabelsBulkResponseData>

export async function apiUpdateIssueLabelsBulk(
  request: UpdateIssueLabelsBulkRequest,
): Promise<UpdateIssueLabelsBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {
    ids: request.ids,
    addedLabelIds: request.addedLabelIds,
    removedLabelIds: request.removedLabelIds,
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await verifiedFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueLabelsBulkResponse>
}
